// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"YouTubeColumnLayout-module--videoWrapper--2ZYlX"};